import router from "../router";
import { useAppState } from "../Stores/AppState";
import { RouteHelper } from "./RouteHelper";

const PREFIX = "[entity-locator-nav]";

/** Opt-in: localStorage.setItem('entityLocatorNavDebug', '1') */
const DEBUG_STORAGE_KEY = "entityLocatorNavDebug";

let activeTraceId = null;
let activeTraceStartedAt = null;

function isEntityLocatorNavDebugEnabled() {
    try {
        return localStorage.getItem(DEBUG_STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

function locatorFlags() {
    const app = useAppState();

    return {
        entity_navigate_with_locator: app.entity_navigate_with_locator,
        suppress_entity_locator_after_document_reload:
            app.suppress_entity_locator_after_document_reload,
        skip_locate_animation: app.skip_locate_animation,
        skipEntityNavigation: RouteHelper.skipEntityNavigation,
        routePath: router.currentRoute.value?.path,
        routeName: router.currentRoute.value?.name,
    };
}

export function startEntityLocatorNavTrace(source, details = {}) {
    if (!isEntityLocatorNavDebugEnabled()) {
        return null;
    }

    activeTraceId = `${source}-${Date.now()}`;
    activeTraceStartedAt = performance.now();

    console.info(PREFIX, {
        traceId: activeTraceId,
        step: "trace.start",
        source,
        elapsedMs: 0,
        ...locatorFlags(),
        ...details,
    });

    return activeTraceId;
}

export function logEntityLocatorNav(step, details = {}) {
    if (!activeTraceId) {
        return;
    }

    console.info(PREFIX, {
        traceId: activeTraceId,
        step,
        elapsedMs:
            activeTraceStartedAt != null
                ? Math.round(performance.now() - activeTraceStartedAt)
                : null,
        ...locatorFlags(),
        ...details,
    });
}

export function endEntityLocatorNavTrace(result = {}) {
    if (!activeTraceId) {
        return;
    }

    logEntityLocatorNav("trace.end", result);
    activeTraceId = null;
    activeTraceStartedAt = null;
}

export function getActiveEntityLocatorNavTraceId() {
    return activeTraceId;
}
